export default __webpack_public_path__ + "static/media/Banner-3.60d7ce74.jpg";